// src/aiq/services/NewsService.ts

// Point to your Python Backend
import { API_BASE_URL } from '../../config'; 

export interface NewsItem {
    title: string;
    // FIX: source is an object, not a string
    source: { 
        id: string | null; 
        name: string; 
    }; 
    publishedAt: string;
    url: string;
    description?: string;
}

export interface SentimentResult {
    ticker: string;
    overall_score: number; // -1 to 1
    summary: string;
    source_articles: NewsItem[];
}

export const fetchSentiment = async (ticker: string, token: string): Promise<SentimentResult | null> => {
    try {
        const response = await fetch(`${API_BASE_URL}/sentiment/${ticker}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        
        if (!response.ok) return null;
        return await response.json();
    } catch (e) {
        console.error(`AiQ News Error (${ticker}):`, e);
        return null;
    }
};

export const fetchImpactAnalysis = async (ticker: string, articles: NewsItem[], token: string) => {
    try {
        const response = await fetch(`${API_BASE_URL}/news/impact_analysis`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ ticker, articles })
        });

        if (!response.ok) return null;
        return await response.json();
    } catch (e) {
        console.error("AiQ Impact Analysis Error:", e);
        return null;
    }
};